<template>
  <div
    class="manualActivation"
  >
    <div
      v-show="detailId===''"
    >
      <div
        class="btn"
      >
        <el-button
          size="small"
          type="primary"
          @click="handleBtn('activation')"
        >
          资源激活
        </el-button>
      </div>
      <el-card>
        <el-form
          inline
          label-suffix="："
          size="small"
        >
          <el-form-item
            label="激活时间"
          >
            <el-date-picker
              v-model="searchForm.time"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @blur="dateBlur"
            />
          </el-form-item>
          <el-form-item
            label="设备SN号"
          >
            <el-input
              v-model="searchForm.deviceSn"
              maxlength="50"
              placeholder="请输入20位数字或字母"
            />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handleBtn('search')"
            >
              查询
            </el-button>
            <el-button
              @click="handleBtn('reset')"
            >
              重置
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <div>
        <el-table
          :data="list"
        >
          <el-table-column
            width="65px"
            label="序号"
          >
            <template
              slot-scope="scope"
            >
              {{ ((page-1) * 10) +scope.$index+1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="deviceSns"
            label="设备SN号"
          >
            <template
              slot-scope="scope"
            >
              {{ handleDeviceSns(scope.row.deviceSns) }}
            </template>
          </el-table-column>
          <el-table-column
            label="激活资源类型"
          >
            <template
              slot-scope="scope"
            >
              {{ handleSplit(scope.row.resourceNames) }}
            </template>
          </el-table-column>
          <el-table-column
            label="附件"
          >
            <template
              slot-scope="scope"
            >
              <el-image
                v-if="scope.row.attachmentUrl"
                style="width: 100px; height: 100px"
                :src="scope.row.attachmentUrl"
                :preview-src-list="[scope.row.attachmentUrl]"
                @click.stop="handleClickItem"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="createDate"
            label="创建时间"
          />
          <el-table-column
            align="center"
            label="操作"
          >
            <template
              slot-scope="scope"
            >
              <el-button
                type="text"
                size="mini"
                @click="handleBtn('detail',scope.row)"
              >
                查看详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="total"
          :page.sync="page"
          :limit.sync="limit"
          @handleSizeChange="getPageSize('list',$event)"
          @pagination="getPageSize('list',$event)"
        />
      </div>
    </div>
    <div
      v-show="detailId !==''"
    >
      <div
        class="back"
      >
        <el-button
          type="primary"
          @click="back"
        >
          返回
        </el-button>
      </div>
      <el-card>
        <el-form
          inline
          label-suffix="："
          size="small"
        >
          <el-form-item
            label="激活时间"
          >
            <el-date-picker
              v-model="detailSearchForm.time"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @blur="dateBlur"
            />
          </el-form-item>
          <el-form-item
            label="激活状态"
          >
            <el-select
              v-model="detailSearchForm.activateStatus"
              placeholder="请选择激活状态"
            >
              <el-option
                v-for="(item,index) in statusList"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="设备SN号"
          >
            <el-input
              v-model="detailSearchForm.deviceSn"
              maxlength="50"
              placeholder="请输入20位数字或字母"
            />
          </el-form-item>
          <el-form-item
            label="虚拟号"
          >
            <el-input
              v-model="detailSearchForm.deviceVsn"
              maxlength="50"
              placeholder="请输入21位数字或字母"
            />
          </el-form-item>
          <el-form-item
            label="资源类型"
          >
            <el-select
              v-model="detailSearchForm.resourceCode"
              placeholder="请选择资源类型"
            >
              <el-option
                label="全部"
                :value="''"
              />
              <el-option
                v-for="(item,index) in typeList"
                :key="index"
                :value="item.code"
                :label="item.name"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handleBtn('detailSearch')"
            >
              查询
            </el-button>
            <el-button
              @click="handleBtn('detailReset')"
            >
              重置
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <div>
        <el-table
          :data="detailList"
        >
          <el-table-column
            width="65px"
            label="序号"
          >
            <template
              slot-scope="scope"
            >
              {{ ((page-1) * 10) +scope.$index+1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="deviceNo"
            label="设备SN号"
          />
          <el-table-column
            prop="accountId"
            label="虚拟号"
          />
          <el-table-column
            label="激活状态"
          >
            <template
              slot-scope="scope"
            >
              <span>
                {{ scope.row.statusName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="equityName"
            label="激活资源类型"
          />
          <el-table-column
            prop="openFailReason"
            label="激活失败原因"
          />
          <el-table-column
            prop="openDate"
            label="激活时间"
          />
          <el-table-column
            align="center"
            label="操作"
          >
            <template
              slot-scope="scope"
            >
              <el-button
                v-if="scope.row.openStatus!==1 && scope.row.openStatus!==2"
                type="text"
                size="mini"
                @click="handleBtn('reactivate',scope.row)"
              >
                重新激活
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="detailTotal"
          :page.sync="detailPage"
          :limit.sync="detailLimit"
          @handleSizeChange="getPageSize('detail',$event)"
          @pagination="getPageSize('detail',$event)"
        />
      </div>
    </div>

    <el-dialog
      width="800px"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      title="资源激活"
      @close="dialogClose"
    >
      <el-form
        ref="editForm"
        :rules="rules"
        label-suffix="："
        size="small"
        label-width="150px"
        :model="editForm"
      >
        <el-form-item
          prop="deviceNos"
          label="课桌SN码"
        >
          <el-input
            v-model="editForm.deviceNos"
            :rows="5"
            style="font-size:16px;margin-bottom:10px"
            type="textarea"
            placeholder="请输入课桌SN码,并且逗号隔开"
          />
          <el-button
            type="primary"
            @click="handleImports"
          >
            导入数据
          </el-button>
          <el-button
            type="primary"
            @click="handleDownload"
          >
            下载模板
          </el-button>
          <span
            style="color:#909399;font-size:12px;"
          >可输入单条或多条SN号，多条SN号以(英文)逗号区分</span>
        </el-form-item>
        <el-form-item
          prop="resourcesList"
          label="激活资源"
        >
          <el-checkbox-group
            v-model="editForm.resourcesList"
          >
            <el-checkbox
              v-for="(item,index) in typeList"
              :key="index"
              :label="item.code"
            >
              {{ item.name }}
            </el-checkbox>
            <!-- <el-checkbox
              :label="2">
              中教云
            </el-checkbox>
            <el-checkbox
              :label="3">
              赶考状元
            </el-checkbox> -->
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          prop="phone"
          label="附件上传"
        >
          <upload-file
            :props="{serveCode:'app_logo',accept:'.png, .jpg, .jpeg',type:['image/jpeg','image/gif','image/png']}"
            @uploadSucess="uploadSucessImgFn"
          >
            <div
              v-if="editForm.attachmentUrl !== ''"
              style="font-size:12px;line-height: 28px;"
            >
              <img
                :src="editForm.attachmentUrl"
                class="avatar"
              >
              <!-- <i
                class="el-icon-refresh"></i>
              <span>重新上传</span> -->
              <el-button
                type="primary"
                class="el-icon-refresh"
              >
                重新上传
              </el-button>
            </div>
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon"
            />
          </upload-file>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="medium"
          @click="dialogVisible = false"
        >
          取消
        </el-button>
        <el-button
          type="primary"
          size="medium"
          @click="handleImport"
        >
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  activation,
  manualActivation,
  getResourceActivationArtificialList,
  getResourceActivationAutoList
} from '@/api/productOperation/financialCenter/resourceActivation.js';
import Pagination from '@/components/Pagination'; // Secondary package based on el-pagination
import { mapGetters } from 'vuex';
import excel from '@/utils/excel';
export default {
  props: {
    typeList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    createUser() {
      return this.userInfo.accountId;
    }
  },
  data() {
    const validateSn = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入SN号'));
      } else {
        const str = value.split(',');
        if (str.some((item) => item.length > 20 && item.length !== 0)) {
          callback(new Error('请输入正确SN号'));
        }
        if (str.length > 100) {
          callback(new Error('最多只能100个SN号'));
        }
        callback();
      }
    };
    return {
      detailSearchForm: {
        time: [],
        activateStatus: '',
        deviceSn: '',
        deviceVsn: '',
        resourceCode: '',
        startDate: '',
        endDate: ''
      },
      detailList: [],
      detailTotal: 0,
      detailPage: 1,
      detailLimit: 10,
      resources: [],
      statusList: [
        { label: '全部', value: '' },
        { label: '激活中', value: 1 },
        { label: '激活成功', value: 2 },
        { label: '激活失败', value: 3 }
      ],
      detailId: '',
      fileList: [],
      pickerMinDate: '', // 选中的第一个时间
      minDate: 90, // 时间范围
      pickerOptions: {
        onPick: (obj) => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            const day1 = this.minDate * 24 * 3600 * 1000;
            const maxTime = this.pickerMinDate + day1;
            const minTime = this.pickerMinDate - day1;
            return time.getTime() > maxTime || time.getTime() < minTime;
          }
        }
      },
      dialogVisible: false,
      editForm: { resourcesList: [], deviceNos: '', attachmentUrl: '' },
      list: [],
      searchForm: { time: [], deviceSn: '', startDate: '', endDate: '' },
      total: 0,
      page: 1,
      limit: 10,
      rules: {
        resourcesList: [
          { required: true, message: '请选择激活资源', trigger: 'change' }
        ],
        deviceNos: [
          { required: true, message: '请输入SN号', trigger: 'change' },
          // { max: 119, message: '最多只能输入10', trigger: 'change' },
          { validator: validateSn, trigger: 'blur' }
        ]
      }
    };
  },
  components: {
    Pagination
  },
  mounted() {
    this.page = 1;
    this.detailId = '';
    this.getData();
  },
  methods: {
    dateBlur() {
      this.pickerMinDate = '';
    },
    handleDeviceSns(val) {
      if (!val) return;
      return val.split(',').join(';');
    },
    handleClickItem() {
      this.$nextTick(() => {
        const domImageMask = document.querySelector('.el-image-viewer__mask'); // 获取遮罩层dom
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click();
        });
      });
    },
    handleSplit(val) {
      if (!val || val.length === 0) return;
      return val.join(',');
    },
    handleDownload() {
      console.log(
        window.location.protocol +
          '//' +
          window.location.host +
          '/' +
          'template.xlsx'
      );
      const link = document.createElement('a');
      link.style.display = 'none';
      link.download = 'SN导入模板.xlsx';
      link.href = './template.xlsx';
      // link.href =
      //   window.location.protocol +
      //   '//' +
      //   window.location.host +
      //   '/' +
      //   'template.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    handleImports() {
      const inputObj = document.createElement('input');
      // 设置属性
      inputObj.setAttribute('id', '_ef');
      inputObj.setAttribute('type', 'file');
      inputObj.setAttribute(
        'accept',
        '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
      );
      inputObj.setAttribute('style', 'visibility:hidden');
      // 添加到DOM中
      document.body.appendChild(inputObj);
      // 添加事件监听器
      inputObj.addEventListener('change', (files) => {
        document.body.removeChild(document.getElementById('_ef'));
        const temp = [];
        Object.keys(files.target.files).map((item) => {
          temp.push(files.target.files[item]);
        });
        temp.map((item) => {
          if (
            item.type &&
            item.size > 0 &&
            item.type ===
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          ) {
            excel.getFirstColumn(item, 'A', (res) => {
              var r = res.filter((item) => {
                const str = item.replace(/\s*/g, '');
                return str.length > 0 && str.length <= 20;
              });
              if (r.length !== res.length) {
                this.$message.warning('已去除错误的SN号');
              }
              if (r.length > 0) {
                if (
                  this.editForm.deviceNos[
                    this.editForm.deviceNos.length - 1
                  ] === ',' ||
                  this.editForm.deviceNos.length === 0
                ) {
                  this.editForm.deviceNos += r.join(',');
                } else {
                  this.editForm.deviceNos = this.editForm.deviceNos + ',';
                  this.editForm.deviceNos += r.join(',');
                }
                const deviceNo = [
                  ...new Set(this.editForm.deviceNos.split(','))
                ];
                this.editForm.deviceNos = deviceNo.join(',');
                if (r.length !== deviceNo.length) {
                  this.$message.warning('已去除重复的SN号');
                }
              } else {
                this.$message.error('请正确填写SN号');
              }
            });
          } else {
            this.$message.error('请选择正确的文件');
          }
        });
      });
      inputObj.click();
    },
    init() {},
    uploadSucessImgFn(val) {
      this.editForm.attachmentUrl = val.absolutePath;
    },
    dialogClose() {
      this.dialogVisible = false;
      this.editForm = {
        resourcesList: [],
        deviceNos: '',
        attachmentUrl: ''
      };
    },
    // 提交
    handleImport() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          const str = this.editForm.deviceNos.split(',');
          var r = str.filter((item) => {
            return item.length > 0;
          });
          const deviceNo = [...new Set(r)];
          const deviceNos = deviceNo.join(',');
          if (r.length !== deviceNo.length) {
            this.$message.warning('已去除重复的SN号');
          }
          const resourceCodes = this.editForm.resourcesList.join(',');
          manualActivation({
            deviceNos,
            resourceCodes,
            createUser: this.createUser,
            attachmentUrl: this.editForm.attachmentUrl
          })
            .then((res) => {
              if (res.code === '0') {
                this.dialogVisible = false;
                this.$message.success('操作成功');
                this.getData();
              }
            })
            .catch((err) => {
              const message = err.data.message.split('\n');
              const str = message.join(' <br/> ');
              this.$message({
                dangerouslyUseHTMLString: true,
                message: str,
                type: 'error'
              });
            });
        }
      });
    },
    back() {
      this.detailId = '';
    },
    handleBtn(e, data) {
      if (e === 'reactivate') {
        this.$confirm('是否继续重新激活', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            activation(data.srcId).then((res) => {
              if (res.code === '0') {
                this.getData();
                this.$message({
                  type: 'success',
                  message: res.message || '激活成功'
                });
              }
            });
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (e === 'activation') {
        // 激活
        const resourcesList = this.typeList.map((item) => item.code);
        this.editForm = {
          resourcesList,
          deviceNos: '',
          attachmentUrl: ''
        };
        this.imageUrl = '';
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.editForm.clearValidate();
        });
      } else if (e === 'detail') {
        this.detailId = data.srcIds;
        this.detailSearchForm = {
          time: [],
          activateStatus: '',
          deviceVsn: '',
          resourceCode: ''
        };
        this.detailPage = 1;
        this.getData();
      } else if (e === 'search') {
        if (this.searchForm.time !== null) {
          this.searchForm.startDate = this.searchForm.time[0] || '';
          this.searchForm.endDate = this.searchForm.time[1] || '';
        } else {
          this.searchForm.startDate = null;
          this.searchForm.endDate = null;
        }
        this.page = 1;
        this.getData();
      } else if (e === 'reset') {
        this.searchForm = {
          time: [],
          deviceSn: '',
          startDate: '',
          endDate: ''
        };
        this.page = 1;
        this.getData();
        this.dateBlur();
      } else if (e === 'detailSearch') {
        if (this.detailSearchForm.time !== null) {
          this.detailSearchForm.startDate = this.detailSearchForm.time[0] || '';
          this.detailSearchForm.endDate = this.detailSearchForm.time[1] || '';
        } else {
          this.detailSearchForm.startDate = null;
          this.detailSearchForm.endDate = null;
        }
        this.detailPage = 1;
        this.getData();
      } else if (e === 'detailReset') {
        this.detailSearchForm = {
          time: [],
          activateStatus: '',
          deviceVsn: '',
          resourceCode: '',
          startDate: '',
          endDate: ''
        };
        this.detailPage = 1;
        this.getData();
        this.dateBlur();
      }
    },
    getPageSize(e, { page, limit }) {
      if (e === 'list') {
        this.page = page;
        this.limit = limit;
      } else {
        this.detailPage = page;
        this.detailLimit = limit;
      }
      this.getData();
    },
    getData() {
      if (this.detailId === '') {
        getResourceActivationArtificialList({
          pageSize: this.limit,
          pageNum: this.page,
          ...this.searchForm
        }).then((res) => {
          this.list = res.data.list;
          this.total = res.data.total;
        });
      } else {
        getResourceActivationAutoList({
          srcIdList: this.detailId,
          pageSize: this.detailLimit,
          pageNum: this.detailPage,
          ...this.detailSearchForm
        }).then((res) => {
          this.detailList = res.data.list.map((item) => {
            return {
              ...item,
              statusName:
                // eslint-disable-next-line eqeqeq
                item.openStatus == 1
                  ? '激活中'
                  : item.openStatus === 2 // eslint-disable-next-line eqeqeq
                    ? '激活成功'
                    : '激活失败'
            };
          });
          this.detailTotal = res.data.total;
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.manualActivation {
  .btn {
    margin: 0 10px 10px;;
    display: flex;
    justify-content: flex-end;
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 5px;
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 300px;
  height: 300px;
  object-fit: contain;
  display: block;
}
.back {
  margin: 10px 0;
}
</style>
